import React, { useEffect, useState } from "react";
import {
  DatePicker,
  Button,
  Skeleton,
  Table,
  Result,
  Checkbox,
  ConfigProvider,
} from "antd";

import {
  formatDateTime,
  generatedISOFormatDateString,
  getLastDayTimeRangeIST,
  getLastDayTimeRangeUTC,
} from "../../../../../../Utils/DateConverstion";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useSelector } from "react-redux";
import TableComponent from "../../../../../Elements/Grid/TableComponent";
import TableComponentReport from "../../../../../Elements/Grid/TableComponentReport";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { FilterOutlined } from "@ant-design/icons";
import Empty from "../../../../../CommonScreens/Empty";
const { RangePicker } = DatePicker;
const MAX_DAYS = 90;
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import minnotra_logo from "../../../../../../Assets/Images/logo2.png";
import SteamTreeSelectCustomWithSelectAll from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";
import PowerTableComponent from "../../../../../Elements/Grid/PowerTableComponent";


// Extend plugins
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
 
const PowerInterruptionReport = () => {
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();



  const [loadings, setLoadings] = useState(true);
  const [excelToDate, setExcelToDate] = useState(null);
  const [excelFromDate, setExcelFromDate] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [value, setValue] = useState([dayjs().subtract(1, "day").startOf("day"),dayjs().startOf("day")]);
    const [fromDateObj, setFromDateObj] = useState(dayjs().subtract(1, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss"));
    const [fromDateString, setFromDateString] = useState(dayjs().subtract(1, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss"));
    const [toDateObj, setToDateObj] = useState(dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"));
    const [toDateString, setToDateString] = useState(dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"));
    const [excelImage, setExcelImage] = useState(null);
   const loggedIn = useSelector((state) => state.user);
  // console.log(loggedIn)


  const [consumptionData, setConsumptionData] = useState([]);
const [loadingData, setLoadingData] = useState(false);

const [fromDate, setFromDate] = useState(dayjs().subtract(7, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss"))
const [toDate, setToDate] = useState(dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"));

  useEffect(()=>{

    setExcelImage(loggedIn?.images?.excelImage?`data:image/png;base64,${loggedIn?.images?.excelImage}`:null);
  },[loggedIn])


  const fetchReportByDate = (fromDate, toDate) => {
  if (!fromDate || !toDate) return;

  setLoadingData(true);
  console.log(fromDate,toDate)

  makeRequest({
    type: APIConstants.POST,
    url: `${APIConstants.ELECTRICAL_POWER_INTERRUPTION_REPORT}?FromDate=${fromDate}&Todate=${toDate}`,
  })
    .then((res) => {
        console.log(res)
        console.log(dayjs(res[0].fromDate).format("YYYY-MM-DD HH:mm:ss"))
      setLoadingData(false);
      setConsumptionData(res || []);
    })
    .catch(() => {
      setLoadingData(false);
      setConsumptionData([]);
    });
};
const handleDateChange = (value) => {
  if (!value) return;
  setValue(value)
  
  const from = value[0].format("YYYY-MM-DD HH:mm:ss");
  const to = value[1].format("YYYY-MM-DD HH:mm:ss");
 
  setFromDate(from);
  setToDate(to);


  fetchReportByDate(from, to);
};

useEffect(()=>{
fetchReportByDate(fromDate,toDate)
},[])


let columns = [
  {
    title: "Meter ID",
    dataIndex: "meterid",
    key: "meterid",
    fixed: "left",
    minWidth: 150,
  },
  {
    title: "Meter Name",
    dataIndex: "metername",
    key: "metername",
    minWidth: 220,
  },
  {
    title: "Converter Name",
    dataIndex: "converterName",
    key: "converterName",
    minWidth: 220,
  },
  {
    title: "Power Disconnect Time",
    dataIndex: "powerDisconnectTime",
    key: "powerDisconnectTime",
    minWidth: 220,
    render: (value) =>{
        dayjs(value).format("YYYY-MM-DD HH:mm:ss")
    console.log(value)    
    }
        //   value && value !== "1900-01-01T00:00:00"
    //     ? dayjs(value).format("YYYY-MM-DD HH:mm:ss")
    //     : "--",
  },
  {
    title: "Power Restore Time",
    dataIndex: "powerRestoreTime",
    key: "powerRestoreTime",
    minWidth: 220,
    render: (value) =>
        dayjs(value).format("YYYY-MM-DD HH:mm:ss")
    //   value && value !== "1900-01-01T00:00:00"
    //     ? dayjs(value).format("YYYY-MM-DD HH:mm:ss")
    //     : "--",
  },
  {
    title: "Outage Duration",
    dataIndex: "powerOutageDurationMinutes",
    key: "powerOutageDurationMinutes",
    minWidth: 200,
  },
  // {
  //   title: "From Date",
  //   dataIndex: "fromDate",
  //   key: "fromDate",
  //   minWidth: 220,
  //   render: (value) => dayjs(value).format("YYYY-MM-DD"),
  // },
  // {
  //   title: "To Date",
  //   dataIndex: "todate",
  //   key: "todate",
  //   minWidth: 220,
  //   render: (value) => dayjs(value).format("YYYY-MM-DD"),
  // },
];

 
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  // //console.log(color);
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--date-ok-btn",
      color.themeConfig.colorPrimary
    );
    document.documentElement.style.setProperty("--date-now-btn", "#fff");
  }, [color]);


  const getImageBufferFromUrl = async (url) => {
    const response = await fetch(url);
    return await response.arrayBuffer();
  };


const exportToExcel = async (data, fromDate, toDate) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Power Outage Report");

  worksheet.mergeCells("A1:B2");
  const logoUrl = excelImage ? excelImage : minnotra_logo;
  const imageBuffer = await getImageBufferFromUrl(logoUrl);
  const imageId = workbook.addImage({
    buffer: imageBuffer,
    extension: "png",
  });

  worksheet.addImage(imageId, {
    tl: { col: 0.2, row: 0.2 },
    ext: { width: 100, height: 38 },
  });

  worksheet.mergeCells("A3:H3");
  worksheet.getCell("A3").value = "Power Interruption Report";
  worksheet.getCell("A3").font = { size: 14, bold: true };
  worksheet.getCell("A3").alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  worksheet.mergeCells("A4:D4");
  worksheet.mergeCells("E4:H4");

  worksheet.getCell("A4").value = `From: ${
    fromDate ? dayjs(fromDate).format("YYYY-MM-DD HH:mm:ss") : "N/A"
  }`;
  worksheet.getCell("E4").value = `To: ${
    toDate ? dayjs(toDate).format("YYYY-MM-DD HH:mm:ss") : "N/A"
  }`;

  worksheet.getRow(4).font = { bold: true };

  const headers = [
    "Meter ID",
    "Meter Name",
    "Converter Name",
    "Power Disconnect Time",
    "Power Restore Time",
    "Outage Duration",
    "From Date",
    "To Date",
  ];
  worksheet.addRow(headers);

  const headerRow = worksheet.getRow(5);
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF00B050" },
    };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  data.forEach((item) => {
    const row = worksheet.addRow([
      item.meterid ?? "--",
      item.metername ?? "--",
      item.converterName ?? "--",

      item.powerDisconnectTime 
        ? dayjs(item.powerDisconnectTime).format("YYYY-MM-DD HH:mm:ss")
        : "--",

      item.powerRestoreTime
        ? dayjs(item.powerRestoreTime).format("YYYY-MM-DD HH:mm:ss")
        : "--",

      item.powerOutageDurationMinutes ?? "--",

      item.fromDate
        ? dayjs(item.fromDate).format("YYYY-MM-DD")
        : "--",

      item.todate
        ? dayjs(item.todate).format("YYYY-MM-DD")
        : "--",
    ]);

    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  worksheet.columns.forEach((col) => {
    let maxLength = 12;
    col.eachCell({ includeEmpty: true }, (cell) => {
      maxLength = Math.max(
        maxLength,
        cell.value ? cell.value.toString().length : 0
      );
    });
    col.width = maxLength + 2;
  });

  const timestamp = dayjs().format("YYYY-MM-DD_HH-mm-ss");
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer]),
    `Power_Interruption_Report_${timestamp}.xlsx`
  );
};


  const today = dayjs();
  const startOfWeek = dayjs().startOf("week").startOf("day"); 
  const endOfWeek = dayjs().endOf("week").startOf("day");     
  
  const startOfLastWeek = dayjs().subtract(1, "week").startOf("week").startOf("day");
  const endOfLastWeek = dayjs().subtract(1, "week").endOf("week").startOf("day");   
  const startOfMonth = dayjs().startOf("month").startOf("day");     
  const endOfMonth = dayjs().endOf("month").startOf("day");       
  const startOfLastMonth = dayjs().subtract(1, "month").startOf("month").startOf("day");
  const endOfLastMonth = dayjs().subtract(1, "month").endOf("month").startOf("day");
  
  const rangePresets = [
    { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.startOf("day")] },
    { label: "This Week", value: [startOfWeek, endOfWeek] },
    { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
    { label: "This Month", value: [startOfMonth, endOfMonth] },
    { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
    { label: "Last 7 Days", value: [dayjs().subtract(7, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 15 Days", value: [dayjs().subtract(15, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 30 Days", value: [dayjs().subtract(30, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 90 Days", value: [dayjs().subtract(90, "day").startOf("day"), today.startOf("day")] },
  ];



  console.log(consumptionData)
  console.log(columns)
  return (
    <div className=" rounded-md w-auto p-4">

      <div className="flex justify-between items-center px-0 pb-0">
        <div className="text-3xl">
          <p
            className={` dark ${isdarkMode ? "darkfont" : "whitemode"} text-center pb-0  ml-0 font-[500] tracking-[1px]`}
          >
            POWER INTERRUPTION REPORT
          </p>
        </div>
        <div className="flex my-2 gap-2">
                <div className="mt-0 flex">
            <RangePicker
            size="large"
              value={value}
              onChange={handleDateChange}
              popupClassName="custom-picker"
              presets={rangePresets}
              format="YYYY-MM-DD HH:mm:ss"
              showTime={{ format: "HH:mm:ss" }}
              className={`w-90 ml-0 shadow-lg rounded-3xl  ${
                isdarkMode
                  ? "customRangePicker-dark  text-white"
                  : "customRangePicker-light text-black"
              }`}
              panelRender={(originalPanel) => {
                if (!showCalendar) {
                  return (
                    <div
                      className={`${
                        isdarkMode ? "bg-[#1a1a1a]" : "bg-white"
                      } flex flex-col gap-1 p-2 w-44 rounded`}
                    >
                      {rangePresets.map((preset) => (
                        <div
                          key={preset.label}
                          onClick={() => handleDateChange(preset.value)}
                          className={`cursor-pointer px-2 py-1 rounded ${
                            isdarkMode
                              ? "text-white hover:bg-gray-700"
                              : "text-black hover:bg-gray-200"
                          }`}
                        >
                          {preset.label}
                        </div>
                      ))}
                      <button
                        onClick={() => setShowCalendar(true)}
                        className={`mt-2 px-2 py-1 rounded  border text-center ${
                          isdarkMode
                            ? "bg-[#1a1a1a] border-white text-white hover:bg-gray-700"
                            : "bg-white border-black text-black hover:bg-gray-200"
                        }`}
                      >
                        Custom Dates
                      </button>
                    </div>
                  );
                }
                return originalPanel;
              }}
              onOpenChange={(open) => {
                if (!open) setShowCalendar(false);
              }}
            />
          </div>
          <Button
            size="large"
            type="primary"
            disabled={consumptionData.length === 0}
            onClick={() =>
              exportToExcel(consumptionData, fromDate, toDate)
            }
          >
            Create Excel
          </Button>
        </div>
      </div>
   {!loadingData && consumptionData.length > 0 && (
  <PowerTableComponent
    report={consumptionData}
    meters={columns}
  />
)}

    {!loadingData && consumptionData.length === 0 &&
       (
        <div
          className={`${!isdarkMode ? "text-black " : "text-white "} text-center`}
        >
          <Empty  isdarkMode={isdarkMode} />
        </div>
      )}
    {loadingData && (
                <Skeleton active paragraph={{ rows: 6 }} />
    
      )}
      <style>
        {`
          .custom-picker .ant-picker-ok .ant-btn{
            background-color: var(--date-ok-btn) !important;
            border-color: var(--date-ok-btn) !important;
            color: white !important;
          }
          .custom-picker .ant-picker-ok .ant-btn:hover {
            background-color: var(--date-ok-btn) !important;
            border-color: #d9363e !important;
          }
          .custom-picker .ant-picker-now .ant-picker-now-btn {
            color: var(--date-ok-btn) !important;
          }
           .custom-picker .anticon-swap-right, .anticon-calendar{
            // background-color: red !important;
            color: var(--date-ok-btn) !important;
          }
        `}
      </style>
    </div>
  );
};

export default PowerInterruptionReport;
